export default __webpack_public_path__ + "static/media/hawai.91d9bf4f.jpg";